const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const {atCMSInfoPage} = require("../core/vault/StateCursors");

const LoadGuard = require("../core/view/LoadGuard");
//const Page404 = require("../core/top/Page404.jsx");

const styles = require("./styles/PageInfo.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, function(props, vaultState) {
		const path = _.get(props, ["cmsPath"], []);
		const cmsData = atCMSInfoPage(vaultState, path).get();
		return {
			cmsData,
		};
	});
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageInfo",

		// React uses a list of properties and their types to verify it is getting
		// all the information it needs
		propTypes: {
			cmsPath: PT.array.isRequired,

			// Injected by HOCs
			cmsData: PT.object.isRequired,
			dispatch: PT.func.isRequired,
		},

		getCMSPath: function() {
			return _.get(this.props, ["cmsPath"], []);
		},

		loadCMSPageInfo: function() {
			this.props.dispatch({
				type: AT.LOAD_CMS_INFO_PAGE_REQUEST,
				path: this.getCMSPath(),
			});
		},

		renderPageInfoMainView: function() {
			const {cmsData} = this.props;
			const htmlContent = _.get(cmsData, ["model", "file"]);
			return (
				<div
					dangerouslySetInnerHTML={{__html: htmlContent}}
					className={styles.main}
				/>
			);
		},

		// This is where you render any HTML needed to display the view.
		render: function() {
			const {cmsData} = this.props;
			return (
				<LoadGuard
					identifier={"cms_data"}
					status={cmsData}
					requestLoad={this.loadCMSPageInfo}
					loadingView="logo"
					loadingViewClass={styles.loading}
					logoColorType="blue"
					renderLoaded={this.renderPageInfoMainView}
					errorView="404Office"
				/>
			);
		},
	})
);
